export const handleMenuMouseLeave = (elementId, resetFn) => {
  if (typeof document === 'undefined') return;
  const mouseTarget = document.getElementById(elementId);
  if (mouseTarget && document.readyState === 'complete') {
    let timeout = null;
    mouseTarget.addEventListener('mouseleave', () => {
      timeout = setTimeout(resetFn, 500);
    });
    mouseTarget.addEventListener('mouseenter', () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    });
  }
};
